import React, { useState } from 'react';
import GlobalMasters from './GlobalMasters';
import TechnicalMasters from './TechnicalMasters';
import UserManagement from './UserManagement';

export default function AdminModule({ db, setDb, saveToDB }) {
  const [activeTab, setActiveTab] = useState("GLOBAL");

  const tabStyle = (tab) => ({
    padding: '12px 24px', cursor: 'pointer', fontWeight: 'bold',
    borderBottom: activeTab === tab ? '4px solid #2563eb' : '4px solid transparent',
    color: activeTab === tab ? '#2563eb' : '#64748b', background: 'transparent', border: 'none', fontSize: '1rem'
  });

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#f8fafc', overflow: 'hidden' }}>
      <div style={{ background: 'white', borderBottom: '1px solid #e2e8f0', padding: '0 20px', display: 'flex', alignItems: 'center', height: '60px', flexShrink: 0 }}>
        <h3 style={{ margin: '0 30px 0 0', color: '#0f172a' }}>ADMINISTRATION (Nirvikalp)</h3>
        <button style={tabStyle("GLOBAL")} onClick={() => setActiveTab("GLOBAL")}>GLOBAL MASTERS</button>
        <button style={tabStyle("TECHNICAL")} onClick={() => setActiveTab("TECHNICAL")}>TECHNICAL DATA</button>
        <button style={tabStyle("USERS")} onClick={() => setActiveTab("USERS")}>USER MANAGEMENT</button>
      </div>

      <div style={{ flex: 1, overflow: 'auto' }}>
        {activeTab === "GLOBAL" && <GlobalMasters db={db} setDb={setDb} saveToDB={saveToDB} />}
        {activeTab === "TECHNICAL" && <TechnicalMasters db={db} setDb={setDb} saveToDB={saveToDB} />}
        {activeTab === "USERS" && <UserManagement db={db} setDb={setDb} saveToDB={saveToDB} />}
      </div>
    </div>
  );
}